import momenttimezone from "moment-timezone";

const DateTimeDisplay = (props) => {
  const newsubmitdate = momenttimezone.unix(props.dateTime);
  var tz = momenttimezone.tz.guess();
  const convertedDate = newsubmitdate.tz(tz);
  let convertdate = convertedDate.format(
    process.env.REACT_APP_DATE_TIME_FORMAT
  );
  return convertdate;
};

export default DateTimeDisplay;
